export default "__VITE_ASSET__EZ5GU3iD__"